import React, { useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHamburger } from '@fortawesome/pro-light-svg-icons';
import { connect } from 'react-redux';
import _ from 'lodash';
import './Careers.scss';

import { addEvent } from '../../APIClient/events';
import { getAllJobs } from '../../Actions/FeaturedActions';
import Loader from '../../Components/Loader/Loader';

const Careers = props => {
  const { featured, getAllJobs } = props;
  const jobs = featured?.jobs || [];

  const getJobsGroupedByDepartment = () => {
    const gruopedJobs = _.groupBy(jobs, 'department');
    const finalJobs = Array.from(Object.entries(gruopedJobs)).map(([department, jobs]) => ({ department, jobs }));

    return finalJobs;
  };

  useEffect(() => {
    addEvent('Careers - Page View');
    getAllJobs();
  }, [jobs.length]);

  return (
    <div className='careers-outer-container'>
      <MetaTags>
        <title>Careers | ShopMy</title>
        <meta property='description' content="We're hiring! Please apply here or email us at careers@shopmy.us." />
      </MetaTags>
      <div className='careers-about-container'>
        <h1>Career Opportunities</h1>
        <h2>Revolutionizing commerce and brand partnerships with cutting-edge technology and our best-in-class creator network.</h2>
        <p className='company-description'>
          ShopMy is an industry-leading affiliate and influencer marketing platform designed to help forward-thinking brands and creators supercharge
          their growth. Our passionate team is made up of highly-motivated, multi-disciplinary experts who are dedicated to redefining the creator
          economy, one meaningful connection at a time. Our flexible, fully-remote work culture prioritizes creativity, problem-solving, and growth
          opportunities.
        </p>
      </div>
      <div className='careers-image-container'>
        <img className='careers-image' src='https://static.shopmy.us/uploads/img-lookbook_item_sibling_47322-1700493782177' alt='shopmy_img' />
        <img className='careers-image' src='https://static.shopmy.us/nyfw_2024.jpg' alt='NYFW 2024' />
        <img className='careers-image' src='https://static.shopmy.us/uploads/02635319-00bb-4c99-ab98-42a7d4c10a66shopmy_sign.jpg' alt='shopmy_img' />
        <img
          className='careers-image'
          src='https://static.shopmy.us/uploads/cd1f6de3-b7e4-43ef-9147-d80897e7e5d7coachella_shopmy_branded_balls.jpg'
          alt='shopmy_img'
        />
      </div>
      <div className='shopmy-perks-container'>
        <div className='shopmy-perks-container-inner'>
          <h2 className='perks-header'>Why Work At ShopMy?</h2>
          <div className='perk-list'>
            <div className='perk'>
              <div className='perk-icon'>
                <FontAwesomeIcon icon={faHamburger} />
              </div>
              <div className='perk-title'>Innovative Market</div>
              <div className='perk-summary'>
                At ShopMy, you'll be at the forefront of creator marketing, a rapidly growing industry. Our platform connects you with top content
                creators and brands globally, offering a unique opportunity to work in an exciting and dynamic environment.
              </div>
            </div>

            <div className='perk'>
              <div className='perk-icon'>
                <FontAwesomeIcon icon={faHamburger} />
              </div>
              <div className='perk-title'>Competitive Salary</div>
              <div className='perk-summary'>
                As a fast-growing company with strong investor backing, we offer competitive salaries and benefits. Our aim is to motivate and
                appreciate our team for their exceptional work, ensuring they feel valued and rewarded.
              </div>
            </div>

            <div className='perk'>
              <div className='perk-icon'>
                <FontAwesomeIcon icon={faHamburger} />
              </div>
              <div className='perk-title'>Workplace Flexibility</div>
              <div className='perk-summary'>
                Founded in 2020, ShopMy has always embraced a remote-first approach. While we fully support working from home, we also provide options
                for those who prefer working in a shared office space. We prioritize flexibility to suit your work style and needs.
              </div>
            </div>

            <div className='perk'>
              <div className='perk-icon'>
                <FontAwesomeIcon icon={faHamburger} />
              </div>
              <div className='perk-title'>Company Events</div>
              <div className='perk-summary'>
                Culture is key at ShopMy. We regularly host company events to foster team connectivity and fun. Recognizing the importance of
                work-life balance, we also offer a generous vacation policy, encouraging our team to take time off and recharge.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='careers-jobs-container'>
        <div className='all-jobs' id='all-jobs'>
          {!jobs?.length ? (
            <Loader />
          ) : (
            <div className='departments'>
              {getJobsGroupedByDepartment().map(departmentObject => {
                const { department, jobs } = departmentObject;

                return (
                  <div key={department} className='department'>
                    <div className='section-header'>{department}</div>
                    <div className='job-listing-container'>
                      {jobs.map(job => {
                        const { title, location, url } = job;

                        return (
                          <a href={url} target='_blank' rel='noreferrer' key={title} className='job-listing'>
                            <div className='job-title'>{title}</div>
                            <div className='job-location'>{location}</div>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { ui, featured } = state;
  return { ui, featured };
};

export default connect(mapStateToProps, { getAllJobs })(Careers);
